<template>
  <div>

    <div class="row menubar">
      <input
        type=text
        ref="search"
        placeholder="Zoeken"
        class="searchInput"
        v-model="search"
      />
      <button
        @click="
        this.subpage === 'today'
          ? this.getToday()
          : this.getReturns()
        "
        class="topbarButton"
        title="Verversen"
      >
        <awesomeIcon icon="sync"/>
      </button>
      <button
        v-if="subpage === 'today'"
        @click="getReturns()"
        class="topbarButton"
        title="Alle tonen"
      >
        <awesomeIcon icon="chart-bar"/>
      </button>
      <button
        v-else
        @click="getToday()"
        class="topbarButton"
        title="Vandaag tonen">
        <awesomeIcon icon="calendar"/>
      </button>
      <button @click="adding=true" class="topbarButton addButton" title="Waarde toevoegen">
        <awesomeIcon icon="plus"/> Rendement toevoegen
      </button>
    </div>

    <div class="card" v-if="results.length > 0">
      <table>
        <thead class="table-legend">
          <tr>
            <th width="20%">Startdatum</th>
            <th>Waarde</th>
            <th width="10%"></th>
          </tr>
        </thead>
        <tr
          v-for="result in slice(
            filter(results, searchFilter),
            currentPage * resultsPerPage,
            (currentPage + 1) * resultsPerPage
          )"
          :key="result.date"
        >
          <td width="20%">{{formatDate(result.date)}}</td>
          <td>{{formatReturn(result.return)}}%</td>
          <td width="10%">
            <button
              class="secondary"
              @click="deleteReturn(dbDate(result.date))"
            >
              <awesomeIcon icon="times"/> Verwijder
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="results.length"
        :resultsPerPage="resultsPerPage"
      />
    </div>

    <modalWindow v-if="adding" @close="adding=false;tooltip=false">
    <div class="titlebar">U-rendement toevoegen</div>
    <div class="form-notice" v-if="tooltip">
      {{tooltipText}}
    </div>
    <form @submit.prevent class="inset">
      <input type="date" v-model="dateInput"/>
      <input type="number" v-model="valueInput" step="0.01" placeholder="Rendement"/>
      <input type="submit" @click="addReturn" value="Toevoegen"/>
    </form>
  </modalWindow>

  </div>
</template>

<script>
import { slice, filter } from 'lodash-es';

export default {
  name: 'AdminUreturn',
  data() {
    return {
      results: [],
      search: '',
      currentPage: 0,
      resultsPerPage: 20,
      subpage: 'all',
      dateInput: null,
      valueInput: 0,
      adding: false,
      tooltip: false,
    };
  },
  created() {
    this.getReturns();
  },
  methods: {
    slice,
    filter,
    formatReturn(value) {
      const returnDecimals = value.toString().split('.')[1];
      if (returnDecimals !== undefined) {
        const decimalLength = returnDecimals.length > 1 ? returnDecimals.length : 2;
        return this.formatPrice(value, false, decimalLength);
      }
      return this.formatPrice(value);
    },
    searchFilter(obj) {
      if (this.formatDate(obj.date).includes(this.search)) {
        return true;
      }
      return false;
    },
    dbDate(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${
        d.getMonth() < 9
          ? `0${d.getMonth() + 1}`
          : d.getMonth() + 1
      }-${
        d.getDate() < 10
          ? `0${d.getDate()}`
          : d.getDate()
      }`;
    },
    formatDate(date) {
      date = date.split('-');
      return `${date[2]}-${date[1]}-${date[0]}`;
    },
    getReturns() {
      this.sdk.getReturns((response) => {
        if (response.status === 200) {
          this.subpage = 'all';
          this.results = response.data;
        }
      });
    },
    getToday() {
      this.sdk.getReturnToday((response) => {
        if (response.status === 200) {
          this.search = '';
          this.subpage = 'today';
          this.results = response.data;
          this.results = [{
            date: new Date().toLocaleDateString(),
            return: response.data.return,
          }];
        }
      });
    },
    addReturn() {
      if (this.dateInput === null || `${this.valueInput}`.trim() === '') {
        this.tooltip = true;
        this.tooltipText = 'Fout tijdens het toevoegen.';
        return;
      }
      this.adding = false;
      this.tooltip = false;
      this.sdk.addReturn(
        this.dateInput,
        parseFloat(this.valueInput),
        (response) => {
          if (response.status === 200) {
            this.dateInput = '';
            this.valueInput = 0;
            this.getReturns();
          } else {
            this.tooltip = true;
            this.tooltipText = 'Fout tijdens het toevoegen.';
          }
        },
      );
    },
    deleteReturn(date) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u dit u-rendement wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteReturn(
              date,
              (response) => {
                if (response.status === 200) {
                  this.getReturns();
                } else {
                  this.tooltip = true;
                  this.tooltipText = 'Fout tijdens het verwijderen.';
                }
              },
            );
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    table-layout:fixed;
  }
  .menubar {
    border-radius: 0;
  }
  .dateInput {
    float: right;
    width: 180px;
    height: 36px;
    border-radius: 0;
    margin: 2px;
  }
  .valueInput {
    float: right;
    width: 90px;
    height: 36px;
    margin: 2px 0;
    border-radius: 0;
  }
  .topbarButton {
    height: 40px;
    margin: 0 5px;
    display: inline-flex;
    align-items: center;
  }
  .addButton {
    float: right;
    gap: 5px;
  }
  .searchInput {
    width: 200px;
    float: left;
    border-radius: 0;
    height: 36px;
    margin: 2px;
  }
</style>
